import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import { Link } from "react-router-dom";
import {Table} from "reactstrap";
import { Card, CardTitle } from "reactstrap";
import { Redirect } from "react-router-dom";
import Axios from "axios";
import base_URL from "../../base_URL";
import { Container } from "@material-ui/core";

class NeededTheme extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userService: [],
    };

    this.loadService = this.loadService.bind(this);
    this.deleteTheme = this.deleteTheme.bind(this);
    this.addToTheme = this.addToTheme.bind(this);
  }

  deleteTheme = async (id) => {
    await Axios.delete(`${base_URL}/neededTheme/del/${id}`);
    this.loadService();
  };

  addToTheme = async (theme,id) => {
    await Axios.post(`${base_URL}/neededTheme/add/${theme}`);
    this.deleteTheme(id);
    this.loadService();
  };

  loadService = async () => {
    await Axios.get(`${base_URL}/neededTheme/all`, {
     
    }).then((response) => {
      this.setState({
        userService: response.data.reverse(),
      });
    });
  };

  componentDidMount() {
   
    this.loadService();
  }

  render() {
    if (localStorage.getItem("Admin1token") == null)
    return <Redirect to="/login" />;



    return (
      <Container  id="container">
        <Card body style={{ margin: "20px" }} id="Card">
          <CardTitle>
            <h1>Users posted for themes</h1>
          </CardTitle>
        </Card>

        <Paper>
          <TableContainer style={{ maxHeight: 500 }}>
            <Table responsive className="table border shadow">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col"> Id</th>
                  <th scope="col">Theme</th>
                  <th scope="col">Actions</th>
                  
                </tr>
              </thead>
              <tbody>
                {this.state.userService.map((theme, index) => (
                  <tr>
                    <th scope="row">{index + 1}</th>
                    <td>{theme.id}</td>
                   
                    <td>{theme.theme}</td>
                    
                    <td>
                     
                      <Link
                        type="button"
                        class="btn btn-danger"
                        onClick={() => this.deleteTheme(theme.id)}
                      >
                        Delete
                      </Link>
                      
                      &nbsp;
                      &nbsp; &nbsp;
                      &nbsp; &nbsp;
                    
                      <Link
                        type="button"
                        class="btn btn-success"
                        onClick={() => this.addToTheme(theme.theme,theme.id)}
                      >
                       Add
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </TableContainer>
        </Paper>
      </Container>
    );
  }
}


export default NeededTheme;
